import React from 'react'
import ProgressiveImage from 'react-progressive-image'
import styled from 'styled-components'

const StyledImg = styled.img`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  ${({ margin }) => margin && `margin: ${margin}`}
`

const Element = ({ name, icon, thumbnail, width = '100%', height = '100%', margin }) => {
  return (
    <ProgressiveImage placeholder={thumbnail} src={icon} style={{ height, width }}>
      {(src, loading) => (
        <StyledImg
          alt={name}
          height={height}
          margin={margin}
          src={src}
          style={{ filter: loading ? 'blur(2px)' : 'none' }}
          width={width}
        />
      )}
    </ProgressiveImage>
  )
}

export default Element
